import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  function toggleSearchButtonClicked() {
    setSearchClicked(!isSearchClicked);
  }

  function toggleMobileMenu() {
    setMobileMenu(!mobileMenu);
  }

  function handleSearchInputChange(event) {
    setSearchQuery(event.target.value);
  }

  function handleSearch() {
    if (searchQuery.trim() !== "") {
      // Redirect to Search.js with the query using useNavigate
      navigate(`/search/${encodeURIComponent(searchQuery)}`);
    }
    setSearchClicked(false);
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  return (
    <>
      <div className="sticky top-0 p-5 bg-[#221F1F] lg:hidden">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-3">
            <div>
              <button onClick={toggleMobileMenu} className="text-xs rounded-xl">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-6 h-6 mt-1"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
              </button>
            </div>
            <div className="text-[#E50914] text-2xl font-bebas rounded-b-6xl text-left">
              <span>theWatcher</span>
            </div>
          </div>
          <div className="flex items-center space-x-2 max-w-20">
            {isSearchClicked ? (
              <div className=" flex items-center w-56 outline-none rounded-sm text-left px-3">
                <input
                  className="outline-none bg-[#221F1F] "
                  type="text"
                  placeholder="Movies, Tv Shows ..."
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onKeyPress={handleKeyPress}
                />

                <button onClick={handleSearch}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <button onClick={toggleSearchButtonClicked}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
                  />
                </svg>
              </button>
            )}
            {/* <div className="flex flex-col items-center group">
              <button onClick={toggleSearchButtonClicked}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
                  />
                </svg>
              </button>
              <span className="text-[10px] text-[#221F1F] group-hover:text-white">Search</span>
            </div> */}
          </div>
        </div>
      </div>
      {mobileMenu && (
        <div
          onClick={toggleMobileMenu}
          className={`fixed inset-0 w-full bg-black bg-opacity-50 z-50 mt-14 ${
            mobileMenu ? "" : "opacity-0 pointer-events-none"
          }`}
        >
          <div
            className={`w-48 h-screen bg-[#221F1F] ${
              mobileMenu ? "translate-x-0" : "-translate-x-full"
            } duration-300 ease-in-out`}
          >
            <div className="text-sm text-left p-5">
              <ul className="list-none flex flex-col items-start justify-start space-y-10">
                <Link to="/">Home</Link>
                <Link to="/tvshows">Tv Shows</Link>
                <Link className="w-full" to="/movies">
                  Movies
                </Link>
              </ul>
            </div>
          </div>
        </div>
      )}

      <div className="select-none sticky top-0 bg-[#221F1F] hidden lg:block">
        <div className="p-3 flex items-center justify-between">
          <div className="flex space-x-10 items-center">
            <div className="text-[#E50914] text-4xl font-bebas rounded-b-6xl">
              <span>theWatcher</span>
            </div>
            <div className="text-sm">
              <ul className="list-none flex space-x-5">
                <Link to="/">Home</Link>
                <Link to="/tvshows">Tv Shows</Link>
                <Link to="/movies">Movies</Link>
              </ul>
            </div>
          </div>
          <div className="flex items-center space-x-2">
            {isSearchClicked ? (
              <div className=" flex items-center w-56 outline-none rounded-sm text-left px-3">
                <input
                  className="outline-none bg-[#221F1F] w-72"
                  type="text"
                  placeholder="Movies, Tv Shows ..."
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onKeyPress={handleKeyPress}
                />

                <button onClick={handleSearch}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                    />
                  </svg>
                </button>
              </div>
            ) : (
              <div className="flex flex-col  items-center group">
              <button onClick={toggleSearchButtonClicked}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
                  />
                </svg>
              </button>
              <span className="text-[10px] text-[#221F1F] group-hover:text-white">Search</span>
            </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}
